import { GET_MODALITY_SEARCH_DEVICE_SUCCESS } from "../actions/servicesAction"

const modalityReducer = (state = [], { type,  data=[] }) => {
  switch (type) {
    case GET_MODALITY_SEARCH_DEVICE_SUCCESS:
      return data
    default:
      return state
  }
}
  
  export default modalityReducer